module.exports = __webpack_public_path__ + "img/hr-dry-tree-02.96fbc2de.png";